import { useSelector, shallowEqual } from "react-redux";
import { getBrandDisplayName, getShowPfsMessage } from "app/reducers/partnerSelector";
import SocialBar from "./SocialBar";

const mapStateToProps = state => {
	return {
		resolution: state.resolution,
		partnerData: state.partnerData,
		brandDisplayName: getBrandDisplayName(state),
		showPfsMessage: getShowPfsMessage(state),
	};
};

const SocialBarContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <SocialBar {...props} {...stateProps} />;
};

export default SocialBarContainer;
